const Blog = () => {
	// fetch blog from backend and render here
	return <div>Blog</div>;
};

export default Blog;
